export const OffCanvas = () => {
  if (window.innerWidth > 767) return

  document.querySelectorAll('.offcanvas .offcanvas-body .btn').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('li')?.querySelector('.collapse')?.classList.add('active')
    })
  })

  document.querySelectorAll('.offcanvas .offcanvas-body .collapse .return-menu').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.collapse')?.classList.remove('active')
    })
  })
}
